// extracted by mini-css-extract-plugin
module.exports = {"button":"MockedButton_button__36w6F","button_unmock":"MockedButton_button_unmock__yL8A6"};